import React from 'react'
import MenuSection from './MenuSection';
import Submenu from './Submenu';
import items2 from '../data2'
const allCategories = [...new Set(items2.map((item) => item.category))];

function Main() {
    return (
    <>
        <Submenu categories={allCategories}/>
            <section className="stats">
                <div className="container">
                    <div className="grid grid-2">
                        <div>
                        {items2.map((menuSection) => {
                            return <MenuSection menuSection={menuSection}/>
                        })}
                        </div>
                        <div className="card cart">
                            <h2>Kontaktní údaje</h2>
                            <ul>
                                <li><i className="fas fa-mobile-alt"></i>  +420 723 198 559</li>
                                <li><i className="fas fa-map-marker-alt"></i> Eaterova třída 24, Praha 2</li>
                                <li><i className="fas fa-at"></i> info@eater.cz</li>
                            </ul>
                        </div> 
                        <div className="mobileShoppingButton">
                            <div className="container">Zobrazit košík</div>
                        </div>        
                    </div>
                </div>
                <div id="lunch"></div>
            </section>
    </>
    )
}

export default Main
